import {
  getLoadInterestsCountApi,
  getLoadsInterestsApi,
  getLoadsInterestsCarrierRepsListApi,
  getLoadsInterestDetailsApi,
  updateUserInterestDetailsApi,
  getLoadsInterestsStatesListApi,
  getOwnerOperatorCarrierInfoApi,
  getUserInterestBidsApi,
} from 'redux/apis/UserInterests';
import { getDispatchesCountApi } from 'redux/apis/tracking';

import { fetchError, fetchStart, fetchSuccess, postSuccess } from './Common';

export const SET_SELECTED_LOAD_INTERESTS = 'SET_SELECTED_LOAD_INTERESTS';
export function setSelectedLoadInterests(selectedLoad) {
  return dispatch => {
    dispatch({
      type: SET_SELECTED_LOAD_INTERESTS,
      payload: selectedLoad,
    });
  };
}

export const GET_LOADS_INTERESTS_COUNT = 'GET_LOADS_INTERESTS_COUNT';
export function getLoadInterestsCount() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getLoadInterestsCountApi()
        .then(res => {
          dispatch({
            type: GET_LOADS_INTERESTS_COUNT,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_LOADS_INTERESTS = 'GET_LOADS_INTERESTS';
export const GET_USER_BID_LOADS = 'GET_USER_BID_LOADS';

export function emptyLoadsInterests(userBidLoads = false) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: userBidLoads ? GET_USER_BID_LOADS : GET_LOADS_INTERESTS,
        payload: [],
        isAppend: false,
        totalLoads: 0,
        isLoadsEnded: false,
      });
      resolve(true);
    });
  };
}

export function getLoadsInterests(data = {}, userBidLoads = false, isLoading = true) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      isLoading && dispatch(fetchStart());
      getLoadsInterestsApi(data)
        .then(res => {
          isLoading && dispatch(fetchSuccess());
          const loadInterests = res.data.interests || [];
          dispatch({
            type: userBidLoads ? GET_USER_BID_LOADS : GET_LOADS_INTERESTS,
            payload: loadInterests,
            isAppend: data.start > 0,
            totalLoads: res.data.total_count,
            isLoadsEnded: loadInterests.length < data.limit,
          });
          resolve(loadInterests);
        })
        .catch(err => {
          isLoading && dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_LOADS_INTERESTS_DETAILS = 'GET_LOADS_INTERESTS_DETAILS';
export function emptyLoadsInterestDetails() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_LOADS_INTERESTS_DETAILS,
        payload: { id: null, users: [], total_count: 0 },
      });
      resolve(true);
    });
  };
}
export function getLoadsInterestDetails(id, isLoading = false) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      isLoading && dispatch(fetchStart());
      getLoadsInterestDetailsApi(id)
        .then(res => {
          isLoading && dispatch(fetchSuccess());
          dispatch({
            type: GET_LOADS_INTERESTS_DETAILS,
            payload: { ...res.data, id: id },
          });
          resolve(res.data);
        })
        .catch(err => {
          isLoading && dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const UPDATE_USER_INTEREST = 'UPDATE_USER_INTEREST';
export function updateUserLoadInterest(id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      updateUserInterestDetailsApi(id, data)
        .then(res => {
          dispatch(fetchSuccess());
          if (data?.comments) {
            dispatch(postSuccess('Comments Updated successfully.'));
            dispatch({
              type: UPDATE_USER_INTEREST,
              payload: { id, comments: data.comments },
            });
          } else if (data?.status === 'Rejected' || data?.status === 'Confirmed') {
            data?.status === 'Rejected' && dispatch(postSuccess('Loads Interests Rejected successfully.'));
            if (data?.status === 'Confirmed') {
              dispatch(postSuccess('Loads Interests Accepted successfully.'));
              setTimeout(()=>{dispatch(postSuccess('Post Refresh load will move to Confirmed Tab.'))},5000);
            }

            dispatch({
              type: UPDATE_USER_INTEREST,
              payload: { id, status: data.status },
            });
          }
          resolve(res);
        })
        .catch(err => {
          console.log(err)
          dispatch(fetchError('There was something issue in responding server'));
          reject(err);
        });
    });
  };
}

export const GET_LOAD_INTERESTS_CARRIER_REP_LIST = 'GET_LOAD_INTERESTS_CARRIER_REP_LIST';
export function getCarrierRepsList() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getLoadsInterestsCarrierRepsListApi()
        .then(res => {
          dispatch({
            type: GET_LOAD_INTERESTS_CARRIER_REP_LIST,
            payload: res?.data?.carrier_reps ?? [],
          });
          resolve(res.data);
        })
        .catch(err => {
          dispatch(fetchError('Failed to fetch carrier rep details'));
          reject(err);
        });
    });
  };
}

export const GET_USER_INTERESTS_BIDS = 'GET_LOAD_INTERESTS_BIDS';
export function getUserInterestBids(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getUserInterestBidsApi(id)
        .then(res => {
          dispatch({
            type: GET_USER_INTERESTS_BIDS,
            payload: res?.data?.bids ?? [],
          });
          resolve(res.data);
        })
        .catch(err => {
          dispatch(fetchError('Failed to user interests Bids'));
          reject(err);
        });
    });
  };
}

export function emptyUserInterestBids() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_USER_INTERESTS_BIDS,
        payload: []
      });
      resolve(true);
    });
  };
}

export const GET_LOAD_INTERESTS_STATES_LIST = 'GET_USER_INTERESTS_STATES_LIST';
export function getStatesList() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getLoadsInterestsStatesListApi()
        .then(res => {
          dispatch({
            type: GET_LOAD_INTERESTS_STATES_LIST,
            payload: {
              originStateList: res?.data?.origin_states ?? [],
              destinationStateList: res?.data?.destination_states ?? []
            }
          });
          resolve(res.data);
        })
        .catch(err => {
          dispatch(fetchError('Failed to fetch carrier rep details'));
          reject(err);
        });
    });
  };
}


export const GET_TRUCKBOOK_HAULS_COUNT = 'GET_TRUCKBOOK_HAULS_COUNT';
export function emptyTruckbookHaulsCount() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_TRUCKBOOK_HAULS_COUNT,
        payload: 0
      });
      resolve(true);
    });
  };
}
export function getTruckbookHaulsCount(owner_operator_id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getDispatchesCountApi({ owner_operator_id })
        .then(res => {
          dispatch({
            type: GET_TRUCKBOOK_HAULS_COUNT,
            payload: res.data?.data?.completed || 0,
          });
          resolve(res.data);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}


export const GET_OWNER_OPERATOR_CARRIER = 'GET_OWNER_OPERATOR_CARRIER';
export function emptyUserMCStatus() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_OWNER_OPERATOR_CARRIER,
        payload: {}
      });
      resolve(true);
    });
  };
}
export function getUserMCStatus(user_id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getOwnerOperatorCarrierInfoApi(user_id)
        .then(res => {
          dispatch({
            type: GET_OWNER_OPERATOR_CARRIER,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}